import React, { useContext } from 'react'
import AddressEntry from './AddressEntry'
import { AddressHistoryContext } from './AddressHistoryContext'
import { createAddressEntryValidator } from './AddressHistoryValidation'
import { HistoryQuestion } from '../HistoryEntry/HistoryQuestion'
import QuestionKey from '../../../Questions/question-key'
import QuestionComponentProps from '../../../Questions/question-component-props'
import { AttributionContext } from '../../../context'

const CardlessAddressHistoryQuestion = (props: QuestionComponentProps) => {
  const {
    updateFollowingPrefillStep,
    ...restProps
  } = props
  const attribution = useContext(AttributionContext)
  const validator = createAddressEntryValidator(attribution)

  return (
    <HistoryQuestion
      {...restProps}
      questionKey={QuestionKey.ADDRESS_HISTORY}
      HistoryContext={AddressHistoryContext}
      EntryComponent={AddressEntry}
      minimumYearsHistoryRequired={3}
      entryValidator={validator}
      updateFollowingPrefillStep={updateFollowingPrefillStep}
    />
  )
}

export default CardlessAddressHistoryQuestion
